import React from "react";
import { useSelector } from "../../store/store";
import { getDashFormattedDateStringFromISOString } from "../../util/date-util";

export function StartDate() {
  const startDate = useSelector((state) => state.dates.startDate);

  return <>{getDashFormattedDateStringFromISOString(startDate!)}</>;
}
